import React, { type ReactNode } from 'react'
import { cn } from '../utils'

export const FilterButton: React.FC<{
    active: boolean;
    onClick: () => void;
    children: ReactNode;
    variant?: 'default' | 'accent' | 'danger' | 'success';
    className?: string;
}> = ({ active, onClick, children, variant = 'default', className }) => {
    const variants = {
        default: active 
            ? 'bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 border-gray-900 dark:border-gray-100' 
            : 'bg-white dark:bg-white/5 text-gray-600 dark:text-gray-400 border-black/[.07] dark:border-white/[.07] hover:bg-gray-50 dark:hover:bg-white/10',
        accent: active 
            ? 'bg-blue-600/10 text-blue-700 dark:text-blue-400 border-blue-200 dark:border-blue-500/20' 
            : 'bg-white dark:bg-white/5 text-gray-600 dark:text-gray-400 border-black/[.07] dark:border-white/[.07] hover:bg-gray-50 dark:hover:bg-white/10',
        danger: active 
            ? 'bg-red-500/10 text-red-700 dark:text-red-400 border-red-200 dark:border-red-500/20' 
            : 'bg-white dark:bg-white/5 text-gray-600 dark:text-gray-400 border-black/[.07] dark:border-white/[.07] hover:bg-gray-50 dark:hover:bg-white/10',
        success: active 
            ? 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-500/20' 
            : 'bg-white dark:bg-white/5 text-gray-600 dark:text-gray-400 border-black/[.07] dark:border-white/[.07] hover:bg-gray-50 dark:hover:bg-white/10',
    }

    return (
        <button
            onClick={onClick}
            className={cn(
                'px-3 py-1.5 rounded-lg text-[12px] font-[500] border transition-all duration-100',
                variants[variant],
                className
            )}
        >
            {children}
        </button>
    )
}